export const replaceAllWithAsterisk = text => text.replace(/./g, '*');

export const replaceWithAsterisk = text => text.replace(/(?!^)[\s\S]/g, '*');

export const replaceMailWithAsterisk = text => text.replace(/(?<=\w{1,})\w/g, '*');
